<template>
  <div class="homePage">
    <div class="fiex" :style="{ top: menuTop + 'px' }">
      <Navigation :active="7"></Navigation>
    </div>
    <div class="right">
      <!-- 标 -->
      <img
        class="bar"
        @click="goUrl('/module/creditValue')"
        src="@/assets/image/module/bg1.png"
      />
      <!-- 好友邀请 -->
      <div class="f-invite">
        <div class="invite-title">{{ $t("module.invite.title1") }}</div>

        <div class="invite-box1">
          <span>{{ $t("module.invite.title2") }}</span>
          <div class="imgs">
            <img src="@/assets/image/module/WX.png" />
            <img src="@/assets/image/module/QQ.png" />
          </div>
        </div>
        <div class="tips1">
          {{ $t("module.invite.title3") }}
        </div>
        <div class="copy-box">
          <div class="content">
            {{ Url }}
          </div>
          <button class="copy-btn" @click="copyText">
            {{ $t("module.invite.title4") }}
          </button>
        </div>
        <div class="invite-box2">
          <span>{{ $t("module.invite.title5") }}</span>
        </div>

        <canvas id="canvas" v-show="!imgshow" class="code"></canvas>
        <img class="code" v-show="imgshow" :src="img" />

        <button @click="downloadImage" class="code-btn">
          {{ $t("module.invite.title6") }}
        </button>
      </div>
      <!-- 我的邀请 -->
      <div class="m-invite">
        <div class="herder-box">{{ $t("module.invite.title7") }}</div>
        <div class="provire-box">
          <div class="left-box">
            <div class="item-box">
              <div class="number">
                {{ friendCount }}<span>{{ $t("module.invite.title8") }}</span>
              </div>
              <div class="text">{{ $t("module.invite.title9") }}</div>
            </div>
            <div class="item-box">
              <div class="number">
                {{ totalPoints }}<span>{{ $t("module.invite.title10") }}</span>
              </div>
              <div class="text">{{ $t("module.invite.title11") }}</div>
            </div>
          </div>
          <div class="search-box">
            <input v-model="name" :placeholder="$t('module.invite.title12')" />
            <img
              class="search"
              @click="getFriends(1)"
              src="@/assets/image/module/search.png"
            />
          </div>
        </div>

        <div class="table-box">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="phone" :label="$t('module.invite.title13')">
            </el-table-column>
            <el-table-column
              prop="registryDate"
              :label="$t('module.invite.title14')"
            >
              <template slot-scope="scope">
                <div class="golds">{{ scope.row.registryDate | dateFrom }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="golds" :label="$t('module.invite.title15')">
              <template slot-scope="scope">
                <div class="golds">{{ scope.row.contribution }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="closedSurveyUnqualifiedRate"
              :label="$t('module.invite.title16')"
            >
              <template slot-scope="scope">
                <div class="golds">
                  {{ scope.row.closedSurveyUnqualifiedRate | toPercentage }}
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-box">
            <el-pagination
              @size-change="getFriends(1)"
              @current-change="getFriends"
              :current-page="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size.sync="size"
              layout="total, sizes, prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <!-- 活动规则 -->
      <div class="h-invite">
        <div class="title">{{ $t("module.invite.title17") }}</div>
        <div class="tips">{{ $t("module.invite.title18") }}</div>
        <div class="tips">{{ $t("module.invite.title19") }}</div>
        <div class="tips">{{ $t("module.invite.title20") }}</div>
        <div class="tips">{{ $t("module.invite.title21") }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Navigation from "@/components/Navigation/side";
import { getRecommendationSummary, getFriends, getAccount } from "@/api/user";
import { copyText, downloadImage } from "@/utils/replace";
import QRCode from "qrcode";
export default {
  filters: {
    dateFrom(data) {
      const date = new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份是从0开始的
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    toPercentage(number) {
      return (number * 100).toFixed(2) + "%";
    },
  },
  data() {
    return {
      menuTop: 86,
      percentage: 0,
      tableData: [],
      tableData2: [],
      friendCount: 0,
      totalPoints: 0,

      page: 1,
      size: 10,
      total: 0,

      page2: 1,
      size2: 10,

      flag: false,

      Url: null,

      userInfo: {},
      img: null,
      imgshow: false,
      name: null,
    };
  },
  components: { Navigation },
  methods: {
    listenScroll() {
      console.log(
        "1111",
        document.body.offsetHeight - document.scrollingElement.scrollTop,
        window.innerHeight
      );
      if (
        document.body.offsetHeight - document.scrollingElement.scrollTop <=
        845
      ) {
        this.menuTop =
          document.body.offsetHeight -
          document.scrollingElement.scrollTop -
          815; //，添加el-menu-item,增加730的数值,减少707相同数值
      } else {
        this.menuTop = 86;
      }
    },
    getRecommendationSummary() {
      getRecommendationSummary().then((res) => {
        if (res.code === 200) {
          this.friendCount = res.data.friendCount;
          this.totalPoints = res.data.totalPoints;
        }
      });
    },

    getFriends(type) {
      if (type) {
        this.page = type;
      }
      getFriends({
        page: this.page,
        size: this.size,
        name: this.name,
      }).then((res) => {
        if (res.code === 200) {
          this.tableData = res.data.list;
          this.total = res.data.dataCount;
        }
      });
    },
    copyText() {
      copyText(this.Url).then((res) => {
        if (res === "复制成功") {
          this.$message.success("复制成功");
        } else {
          this.$message.warning("复制失败");
        }
      });
    },
    downloadImage() {
      downloadImage(this.img, "邀请码");
    },
    goUrl(path) {
      this.$router.push(path);
    },
  },
  async created() {
    window.addEventListener("scroll", this.listenScroll);
    this.getFriends();

    this.getRecommendationSummary();
  },
  async mounted() {
    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.$store.commit("changeUserInfo", this.userInfo);
    } else {
      await getAccount().then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.$store.commit("changeUserInfo", this.userInfo);
          localStorage.setItem("userInfo", JSON.stringify(res.data));
        }
      });
    }
    let canvas = document.getElementById("canvas");
    this.Url =
      process.env.VUE_APP_SERVER +
      "register" +
      `?refer=${this.userInfo.recommendedCode}`;

    QRCode.toCanvas(canvas, this.Url, { width: 194, height: 192 }, (error) => {
      if (error) console.error(error);
    });

    this.img = canvas.toDataURL("image/png");
    this.imgshow = true;
  },
  destroyed() {
    window.removeEventListener("scroll", this.listenScroll);
  },
};
</script>
<style scoped>
.table-box >>> .el-table__header .el-table__cell {
  background-color: #fafbfc;
  color: #474f66;
  font-size: 14px;
  font-weight: bolder;
  text-align: center;
}
.table-box >>> .el-table__body .el-table__cell {
  text-align: center;
  color: #474f66;
  font-size: 14px;
}
</style>

<style lang="scss" scoped>
.homePage {
  min-height: 500px;
  display: flex;
  justify-content: flex-end;
  .fiex {
    position: fixed;
    left: 140px;
    transition: top ease 0.1s;
  }
  .right {
    flex-shrink: 0;
    width: calc(100% - 480px);
    margin-right: 140px;
    padding-top: 16px;
    // 标
    .bar {
      width: 100%;
      border-radius: 4px;
      cursor: pointer;
    }
    //好友邀请
    .f-invite {
      width: 100%;
      padding: 25px;
      box-sizing: border-box;
      margin-top: 16px;
      background-color: #fff;
      .invite-title {
        font-size: 16px;
        color: #474f66;
        font-weight: bolder;
      }
      .invite-box1 {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #474f66;
        margin-top: 30px;
        font-weight: bolder;
        span {
          margin-top: 8px;
        }
        .imgs {
          display: flex;
          img {
            width: 35px;
            height: 35px;
            margin-left: 20px;
          }
        }
      }
      .tips1 {
        color: #8948ff;
        font-size: 14px;
        font-weight: bolder;
        margin-top: 9px;
      }
      .copy-box {
        display: flex;
        margin-top: 12px;
        align-items: center;
        .content {
          width: 670px;
          background: #fafafa;
          border-radius: 2px;
          padding: 12px 28px 13px 14px;
          box-sizing: border-box;
          word-wrap: break-word;
          word-break: break-all;
          color: #474f66;
          font-size: 14px;
        }
        .copy-btn {
          flex-shrink: 0;
          margin: 0 35px;
          padding: 0;
          border: none;
          padding: 0 24px;
          height: 32px;
          border-radius: 16px;
          background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
          font-size: 14px;
          color: #ffffff;
          text-align: center;
          cursor: pointer;
        }
      }
      .invite-box2 {
        margin-top: 50px;
        span {
          color: #474f66;
          font-weight: bolder;
          font-size: 14px;
        }
      }
      .code {
        width: 100px;
        height: 100px;
        margin-top: 25px;
        margin-left: 7px;
      }
      .code-btn {
        display: block;
        padding: 0;
        border: none;
        padding: 0 24px;
        height: 32px;
        border-radius: 16px;
        background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        margin-top: 25px;
        margin-bottom: 60px;
        cursor: pointer;
      }
    }
    // 我的邀请
    .m-invite {
      margin-top: 16px;
      background-color: #fff;
      .herder-box {
        width: 100%;
        height: 100px;
        background-image: url("../assets/image/module/bg2.png");
        background-size: cover;
        background-position: 100% 100%;
        background-repeat: no-repeat;
        box-sizing: border-box;
        font-size: 16px;
        font-weight: bolder;
        color: #474f66;
        padding: 23px 29px;
      }
      .provire-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        box-sizing: border-box;
        position: relative;
        padding: 0 25px;
        .left-box {
          display: flex;
          .item-box {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-right: 100px;
            .number {
              font-size: 44px;
              color: #8948ff;
              font-weight: bolder;
              span {
                font-size: 16px;
                color: #474f66;
                margin-left: 7px;
                // font-weight: normal;
              }
            }
            .text {
              font-size: 14px;
              color: #474f66;
              font-weight: bolder;
              margin-top: 8px;
            }
          }
        }
        .search-box {
          position: relative;
          width: 186px;
          height: 41px;
          box-sizing: border-box;
          input {
            padding: 0;
            border: none;
            outline: none;
            width: 100%;
            padding-left: 24px;
            padding-right: 50px;
            height: 41px;
            box-sizing: border-box;
            background: #fafafa;
          }
          .search {
            position: absolute;
            width: 18px;
            height: 18px;
            right: 24px;
            top: 11.5px;
            cursor: pointer;
          }
        }
      }
    }
    //活动规则
    .h-invite {
      margin-top: 16px;
      margin-bottom: 20px;
      width: 100%;
      padding: 15px 25px;
      box-sizing: border-box;
      background-color: #fff;
      .title {
        font-size: 16px;
        color: #474f66;
        font-weight: bolder;
        margin-bottom: 26px;
      }
      .tips {
        margin-bottom: 12px;
        font-size: 14px;
        color: #474f66;
      }
      .tips:last-child {
        margin-bottom: 60px;
      }
    }
  }
}
.pagination-box {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  margin-right: 25px;
}
</style>
<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1400px) {
  .homePage {
    .fiex {
      left: 70px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 340px);
      margin-right: 70px;
    }
  }
}

@media only screen and (max-width: 1300px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
    }
  }
}

@media only screen and (max-width: 1200px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
      .sign-box {
        flex-direction: column;
        .sign {
          width: 100%;
        }
      }
    }
  }
}

@media only screen and (max-width: 1000px) {
  .homePage {
    .fiex {
      display: none;
    }
    .right {
      width: calc(100% - 30px);
      margin-right: 15px;
      .f-invite {
        width: 100%;
        padding: 12px;
        box-sizing: border-box;
        margin-top: 16px;
        background-color: #fff;
        .invite-title {
          font-size: 16px;
          color: #474f66;
          font-weight: bolder;
        }
        .invite-box1 {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          color: #474f66;
          margin-top: 30px;
          font-weight: bolder;
          span {
            margin-top: 8px;
          }
          .imgs {
            display: none;
            img {
              width: 35px;
              height: 35px;
              margin-left: 20px;
            }
          }
        }
        .tips1 {
          color: #8948ff;
          font-size: 14px;
          font-weight: bolder;
          margin-top: 9px;
        }
        .copy-box {
          display: flex;
          margin-top: 12px;
          align-items: flex-start;
          flex-direction: column;
          .content {
            width: 100%;
            background: #fafafa;
            border-radius: 2px;
            padding: 12px 28px 13px 14px;
            box-sizing: border-box;
            word-wrap: break-word;
            word-break: break-all;
            color: #474f66;
            font-size: 14px;
          }
          .copy-btn {
            flex-shrink: 0;
            margin: 0;
            padding: 0;
            border: none;
            padding: 0 24px;
            height: 32px;
            border-radius: 16px;
            background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
            font-size: 14px;
            color: #ffffff;
            text-align: center;
            margin-top: 18px;
          }
        }
        .invite-box2 {
          margin-top: 50px;
          span {
            color: #474f66;
            font-weight: bolder;
            font-size: 14px;
          }
        }
        .code {
          width: 100px;
          height: 100px;
          margin-top: 25px;
          margin-left: 7px;
        }
        .code-btn {
          display: block;
          padding: 0;
          border: none;
          padding: 0 24px;
          height: 32px;
          border-radius: 16px;
          background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
          font-size: 14px;
          color: #ffffff;
          text-align: center;
          margin-top: 25px;
          margin-bottom: 60px;
        }
      }
      .m-invite {
        .herder-box {
          padding: 12px;
        }
        .provire-box {
          padding: 0 12px;
          .search-box {
            display: none;
          }
        }
        .table-box {
          padding: 12px;
        }
      }
      .h-invite {
        padding: 12px;
      }
    }
  }
}

@media only screen and (max-width: 750px) {
  .homePage {
    .fiex {
      display: none;
    }
  }
}
</style>